import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../styles/admins/invoices/invoice.css";
import convertAmountToWords from "../../confs/amount_words";

const rowOne = { width: "7%", textAlign: "center" };
const rowTwo = { width: "68%" };
const rowThree = { borderRight: "none", width: "25%", textAlign: "right" };

function ExtraInvoice(props) {
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      setTimeout(() => {
        props.toggleHeader();
        props.invoiceToggler();
      }, 500);
    },
  });

  const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);


      const hotelDetail = props.clientDetails;
      console.log(hotelDetail);

  const guests = JSON.parse(localStorage.getItem("guests"));

  // Function to get guest details by guestId
  const getGuestDetails = (guestId) => {
    const guest = guests.find((g) => g.id === guestId);
    if (guest) {
      if (guest.is_com) {
        guest.name = JSON.parse(props.invoiceDetails.guest_data).name[0];
        var guestName = "";
        const Gname = guest.name.split(",");
        if (Gname.length > 1) {
          guestName = Gname[1];
          for (let i = 2; i < Gname.length; i++) {
            guestName = guestName + "," + Gname[i];
          }
        }
        return {
          name: Gname[0],
          guest_name: guestName,
          contact: guest.contact,
          comp_contact: guest.comp_contact ?? "",
          address: guest.address,
          is_com: guest.is_com,
        };
      } else {
        return {
          name: guest.name,
          contact: guest.contact,
          address: guest.address,
          is_com: guest.is_com,
        };
      }
    } else {
      return {
        name: JSON.parse(props.invoiceDetails.guest_data).name[0],
        contact: "",
      };
    }
  };

  const guestData = getGuestDetails(
    JSON.parse(props.invoiceDetails.guest_data).id[0]
  );

  return (
    <section className="text-center align-items-center">
      <div className="invoice-outer col-lg-6 col-md-10 col-12" ref={contentRef}>
        <div className="invoice-container">
          <div className="invoice-header">
            <h2 style={{ fontSize: "30px" }}>
              {clientDetails.business_name.toUpperCase()}
            </h2>
            {clientDetails.tagline && (
              <p>{clientDetails.tagline.toUpperCase()}</p>
            )}
            <p>{clientDetails.address.toUpperCase()}</p>
            <p style={{ fontSize: "15.5px" }}>
              Contacts: {clientDetails.contact}
            </p>
            {clientDetails.email && (
              <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                {clientDetails.email}
              </p>
            )}
            <h2 style={{ fontSize: "18px" }}>{hotelDetail.gstin_show == '1' ? 'TAX INVOICE' : 'INVOICE'}</h2>
          </div>

          <div className="invoice-details">
            <div className="registrations">
                              {hotelDetail.gstin_show == '1' ?
              clientDetails.gstin !== null && (
                <p>GSTIN: {clientDetails.gstin}</p>
              ): (<p></p>)
            }              {clientDetails.fssai !== null && clientDetails.fssai && (
                <p>FSSAI No.: {clientDetails.fssai}</p>
              )}
              {clientDetails.oyo_reg !== null && clientDetails.oyo_reg && (
                <p>OYO Reg No.: {clientDetails.oyo_reg}</p>
              )}
            </div>
            <div className="client-details">
              <div className="invoice-meta text-start">
                <p>
                  Company Name: <b>{guestData.is_com ? guestData.name : ""}</b>
                </p>
                <p>Company GST: {guestData.is_com ? guestData.contact : ""}</p>
                <p>
                  Guest Name:&nbsp;
                  <b>
                    {guestData.is_com ? guestData.guest_name : guestData.name}
                  </b>
                </p>
                <p>
                  Guest Contact:{" "}
                  {guestData.is_com
                    ? guestData.comp_contact
                    : guestData.contact}
                </p>
              </div>
              <div className="invoice-meta text-start">
                <p>Invoice No: INV{props.invoiceDetails.booking_id}&nbsp;&nbsp;|&nbsp; FY&nbsp;
  {
    (() => {
      const year = parseInt(props.invoiceDetails.to_date.slice(0, 4));
      const month = parseInt(props.invoiceDetails.to_date.slice(5, 7));
      const fyStart = month < 4 ? year - 1 : year;
      const fyEnd = fyStart + 1;
      return `${fyStart.toString().slice(-2)}-${fyEnd.toString().slice(-2)}`;
    })()
  }       </p>
                <p>Room No: {props.invoiceDetails.room_no}</p>
                <p>
                  Check In: {props.invoiceDetails.from_date.slice(8, 10)}-
                  {props.invoiceDetails.from_date.slice(5, 7)}-
                  {props.invoiceDetails.from_date.slice(0, 4)}{" "}
                  {props.invoiceDetails.from_date.slice(11, 16)}
                </p>
                <p>
                  Checkout: {props.invoiceDetails.to_date.slice(8, 10)}-
                  {props.invoiceDetails.to_date.slice(5, 7)}-
                  {props.invoiceDetails.to_date.slice(0, 4)}{" "}
                  {props.invoiceDetails.to_date.slice(11, 16)}
                </p>
              </div>
            </div>
            <div style={{ height: "48px" }}>
              <p className="address-line">Address: {guestData.address}</p>
            </div>
            <div
              style={{
                height: "380px",
                borderBottom: "1px solid #000000",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url(${clientDetails.image})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "270px",
                  opacity: 0.1, // Sets only the background opacity
                  zIndex: 0, // Ensure it's behind the content
                }}
              ></div>
              <table className="invoice-table">
                <thead>
                  <tr>
                    <th style={rowOne}>S.No.</th>
                    <th style={rowTwo}>Particulars</th>
                    <th style={rowThree}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {props.printFood && (
                    <tr>
                      <td style={rowOne}>1</td>
                      <td style={rowTwo}>Food Bill</td>
                      <td style={rowThree}>
                        ₹ {props.invoiceDetails.food_price}
                      </td>
                    </tr>
                  )}
                  {props.printExtra && (
                    <tr>
                      <td style={rowOne}>{props.printFood ? "2" : "1"}</td>
                      <td style={rowTwo}>Extra Charges</td>
                      <td style={rowThree}>
                        ₹ {props.invoiceDetails.extra_charges}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="invoice-total">
              {/* <p>
                Gross Total:&nbsp;&nbsp; ₹&nbsp;
                {(
                  (props.printExtra ? props.invoiceDetails.extra_charges : 0) +
                  (props.printFood ? props.invoiceDetails.food_price : 0)
                ).toFixed(2)}
              </p> */}
<p>
  Gross Total: ₹&nbsp;
  {(
    (props.printExtra ? parseFloat(props.invoiceDetails.extra_charges || 0) : 0) +
    (props.printFood ? parseFloat(props.invoiceDetails.food_price || 0) : 0)
  ).toFixed(2)}
</p>
            </div>
            <div
              style={{ height: "25px", justifyContent: "space-between" }}
              className="invoice-total d-flex"
            >
              <p>Payment Method: {props.invoiceDetails.payment_method}</p>
              
              {hotelDetail.gstin_show == '1' ? <p>
Grand Total: ₹&nbsp;
{(
  (props.printExtra ? parseFloat(props.invoiceDetails.extra_charges || 0) : 0) +
  (props.printFood ? parseFloat(props.invoiceDetails.food_price || 0) : 0)
).toFixed(2)}

              </p>: <p> </p>}
            </div>
            <p
              style={{
                fontWeight: "500",
                fontSize: "14px",
                textAlign: "start",
                margin: "0 5px",
              }}
            >
              Amount in words:{" "}
              {/* {convertAmountToWords(
                (props.printExtra ? props.invoiceDetails.extra_charges : 0) +
                  (props.printFood ? props.invoiceDetails.food_price : 0)
              )} */}
{convertAmountToWords(
  (props.printExtra ? parseFloat(props.invoiceDetails.extra_charges || 0) : 0) +
  (props.printFood ? parseFloat(props.invoiceDetails.food_price || 0) : 0)
)}
            </p>
            <div className="footer-data">
              <div className="left-foot" style={{ paddingBottom: "5px 0" }}>
                <div className="invoice-footer">
                  {props.printRemarks && (
                    <p
                      style={{
                        fontWeight: "400",
                        margin: "0",
                      }}
                    >
                      Remarks: {props.invoiceDetails.remarks}
                    </p>
                  )}
                </div>
                <strong style={{ textAlign: "start" }}>
                  <pre style={{ margin: "0" }}>
                    {clientDetails.footer_contents}
                  </pre>
                </strong>
              </div>
              <div className="right-foot">
                <p>For {clientDetails.business_name}</p>
                {clientDetails.sign_image && (
                  <img
                    src={clientDetails.sign_image}
                    alt="Signature"
                    height={"80px"}
                    width={"140px"}
                  />
                )}
                <p>Authorised Signature</p>
              </div>
            </div>
            {/* <p style={{ textAlign: "center", fontWeight: "500", margin: "0" }}>
              Thank you for your stay
            </p> */}
          </div>

          {/* Print Button */}
        </div>
      </div>
      <br />
                  <div className="d-flex justify-content-center">
<button
  className="print-btn me-3"
 onClick={() => props.setShowInvoiceE(false)}>
  Go Back
</button>
      <button className="print-btn" onClick={reactToPrintFn}>
        Print Invoice
      </button>
    </div>
    </section>
  );
}

export default ExtraInvoice;
